import React from "react";
import { motion } from "framer-motion";
import About from "../components/About";

const AboutPage = () => {
  return (
    <>
      <About />
    </>
  );
};

export default AboutPage;
